const YearRange = {
    starts: 1996,
    ends: 2023,
}

export const YearList = Array.from({ length: YearRange.ends - YearRange.starts + 1 }, (v, k) => YearRange.starts + k).reverse();
